import React from 'react';

function Footer() {
  return (
    <footer id="contact" className="bg-red-900 text-cream py-10">
      <div className="max-w-6xl mx-auto px-4 text-center">
        <p className="text-lg font-semibold mb-2">Pecel Madiun</p>
        <p className="mb-4 opacity-90">Experience the soulful taste of East Java's most beloved traditional dish.</p>
        <p className="text-cream-dark">Designed for food lovers who crave heritage, spice, and freshness.</p>
        <p className="mt-6 text-sm opacity-80">&copy; 2026 Pecel Madiun. All rights reserved.</p>
      </div>
    </footer>
  );
}

export default Footer;
